import { ICustomerBalance } from '../_types'
import { request } from './http-client'

interface ILoginConfirm {
  created_at: string
  date_of_birth: string
  id: string
  name: string
  phone: string
}

interface IGooglePhonePayload {
  phone: string
  tag?: string
}

interface IGPConfirmPayload {
  phone_number: string
  otp: string
}

export interface IClickMiniAppAuthResponse {
  access_token: string
  created_at: string
  id: string
  is_blocked: boolean
  name: string
  phone: string
  refresh_token: string
  accepted_offer: boolean
}

const customerService = {
  getUserByPhone: (data: any) => request.post('/v1/customers/phone', data),
  loginConfirm: (data: any, platform_id?: string) =>
    request.post<ILoginConfirm>('/v1/customers/confirm-login', data, {
      headers: {
        Platform: platform_id,
      },
    }),
  create: (data: any, platform_id?: string) =>
    request.post('/v1/customers', data, {
      headers: {
        Platform: platform_id,
      },
    }),
  registerConfirm: (data: any, platform_id?: string) =>
    request.post('/v1/customers/register-confirm', data, {
      headers: {
        Platform: platform_id,
      },
    }),
  register: (data: any) => request.post('/v1/customers/register', data),
  login: (data: any) => request.post('/v1/customers/login', data),
  deleteProfile: (id: string) =>
    request.delete(`/v2/customers/self-delete/${id}`),
  loginWithoutOTP: (data: any, platform_id: string) =>
    request.post('/v2/customers/login-without-otp', data, {
      headers: {
        Platform: platform_id,
      },
    }),
  registerWithoutOTP: (data: any, platform_id?: string) =>
    request.post('/v2/customers/register-without-otp', data, {
      headers: {
        Platform: platform_id,
      },
    }),
  update: (id: string, data: any) => request.put('/v1/customers/' + id, data),
  getIikoCustomerInfo: (params: any) =>
    request.post<ICustomerBalance>('/v2/crm/iiko-customer-info', undefined, {
      params,
    }),
  clickMiniAppAuth: (web_session: string, shipper_id: string) =>
    request.post<IClickMiniAppAuthResponse>(
      '/v2/customers/click-mini-app-auth',
      { web_session },
      {
        headers: { Shipper: shipper_id },
      }
    ),
  google: {
    setPhone: (data: IGooglePhonePayload) =>
      request.post('/v2/customers/google-auth-phone-set-with-otp', data),
    confirm: (data: IGPConfirmPayload) =>
      request.post(
        '/v2/customers/google-auth-phone-set-with-otp-confirm',
        data
      ),
    setPhoneWithoutOTP: (data: IGooglePhonePayload) =>
      request.post('/v2/customers/google-auth-phone-set-without-otp', data),
  },
}

export default customerService
